import { createSlice } from '@reduxjs/toolkit';

// Define a type for the slice state
interface StakingState {
  totalSREP: number;
}

// Define the initial state using that type
const initialState: StakingState = {
  totalSREP: 0,
};

export const stakeSlice = createSlice({
  name: 'staking',
  initialState,
  reducers: {
    setSREP: (state, action) => {
      state.totalSREP = action.payload;
    },
  },
});

export const { setSREP } = stakeSlice.actions;

export const stakeReducer = stakeSlice.reducer;
